const getCsrfToken = () => {
    const meta = document.querySelector('meta[name="csrf-token"]');
    return meta ? meta.getAttribute('content') : '';
};

export const csrfFetch = (url, options = {}) => {
    const headers = new Headers(options.headers || {});
    const token = getCsrfToken();

    headers.set('X-Requested-With', 'XMLHttpRequest');

    if (token && !headers.has('X-CSRF-TOKEN')) {
        headers.set('X-CSRF-TOKEN', token);
    }

    return fetch(url, {
        credentials: 'same-origin',
        ...options,
        headers,
    });
};

export const csrfJsonFetch = (url, options = {}) => {
    const headers = new Headers(options.headers || {});

    if (!headers.has('Content-Type')) {
        headers.set('Content-Type', 'application/json');
    }

    if (!headers.has('Accept')) {
        headers.set('Accept', 'application/json');
    }

    return csrfFetch(url, {
        ...options,
        headers,
    });
};
